(function () {
    // Permet de créer le clic ou le touch (pour les écrans tactiles).
    const clickEventType = document.documentElement.ontouchstart !== null ? 'click' : 'touchstart';
    const divSearchGestmaxAll = document.querySelectorAll('.js-gestmax-search');
    divSearchGestmaxAll.forEach(divSearchGestmax => {
        // Lancement d'une première recherche (initialisation)
        searchWithPage(1, divSearchGestmax);
        // Placement des écouteurs sur le bouton "Submit" du formulaire de recherche, ainsi que sur le sélecteur de type de contrat.
        divSearchGestmax.querySelector(".js-gestmax-submit").addEventListener(clickEventType, () => search(divSearchGestmax));
        divSearchGestmax.querySelector('.js-gestmax-select').addEventListener(clickEventType, () => search(divSearchGestmax));
    })

    /**
     * Effectue une recherche pour l'élément (HTML) de recherche passé en paramètre.
     * @param divSearchGestmax L'élément (HTML) qui contient la recherche.
     */
    function search(divSearchGestmax) {
        let page = divSearchGestmax.dataset.page;
        searchWithPage(page, divSearchGestmax);
    }

    /**
     * Effectue une recherche
     * @param event L'évènement soulevé (utilisé pour récupérer la page).
     * @param divSearchGestmax L'élément (HTML) qui contient la recherche.
     */
    function searchToPage(event, divSearchGestmax) {
        let page = event.target.value;
        searchWithPage(page, divSearchGestmax);
    }

    /**
     * Récupération des résultats de recherche.
     * @param page La page.
     * @param divSearchGestmax L'élément (HTML) qui contient la recherche.
     */
    function searchWithPage(page, divSearchGestmax) {
        let url = '/tan/gestmax/search?';
        let instance = divSearchGestmax.dataset.instance;
        let keyword = divSearchGestmax.querySelector("input[name='keyword']");
        let contrat = divSearchGestmax.querySelector("select[name='contrat']");
        // Récupération de la valeur du token
        url = url.concat('instance=' + instance + '&keyword=' + keyword.value + '&contrat=' + contrat.value + '&page=' + page);
        // Envoi d'une requête vers le contrôleur
        xhr('GET', url, function success(req) {
            console.debug('Une réponse a été reçue : ' + req.responseText);
            const divResultGestmax = divSearchGestmax.querySelector('.js-gestmax-result');
            divResultGestmax.innerHTML = req.responseText;
            document.querySelector(".js-gestmax-page").addEventListener(clickEventType, event => searchToPage(event, divSearchGestmax));
        }, function error(req) {
            console.log('Une erreur est survenue (erreur : ' + req.status + ').');
        });
    }

    /**
     * Exécute une requête AJAX.
     * @param method Méthode de la requête (GET, POST, …)
     * @param url URL à appeler
     * @param success Callback quand l'appel a abouti et renvoyé des données
     * @param error Callback quand l'appel a échoué
     */
    function xhr(method, url, success, error) {
        let req = new XMLHttpRequest();
        req.addEventListener('loadend', function () {
            if (req.status !== 200) {
                error(req);
            } else {
                success(req);
            }
        });
        req.open(method, url);
        req.send();
    }
})();